'use client'

type UmamiInstance = {
  identify: (idOrData: string | Record<string, unknown>, data?: Record<string, unknown>) => void
  track: (eventNameOrPayload?: string | Record<string, unknown> | ((props: Record<string, unknown>) => Record<string, unknown>), data?: Record<string, unknown>) => void
}

function getUmami(): UmamiInstance | undefined {
  return (globalThis as any).umami as UmamiInstance | undefined
}

/**
 * Aguarda o script do Umami ser carregado (máx 2s) e chama umami.identify.
 * Seguro para uso com `strategy="afterInteractive"` no Next.js.
 *
 * @param distinctId - Identificador único do usuário (ex: email)
 * @param data - Dados adicionais da sessão (ex: { name, email })
 */
export async function umamiIdentify(distinctId: string, data?: Record<string, unknown>): Promise<void> {
  const start = Date.now()

  while (!getUmami() && Date.now() - start < 2000) {
    await new Promise(r => setTimeout(r, 50))
  }

  const umami = getUmami()

  if (!umami) {
    return
  }

  if (data) {
    umami.identify(distinctId, data)
  } else {
    umami.identify(distinctId)
  }
}

/**
 * Dispara um evento customizado no Umami de forma segura.
 *
 * @param eventName - Nome do evento
 * @param data - Dados do evento (opcional)
 */
export async function umamiTrack(eventName: string, data?: Record<string, unknown>): Promise<void> {
  const start = Date.now()

  while (!getUmami() && Date.now() - start < 2000) {
    await new Promise(r => setTimeout(r, 50))
  }

  const umami = getUmami()

  if (!umami) {
    return
  }

  if (data) {
    umami.track(eventName, data)
  } else {
    umami.track(eventName)
  }
}
